import { MerchantPartyInfo } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantParty/MerchantPartyInfo";
import { ContactPersons } from "Components/Shared/Merchant/ContactPersons/ContactPersons";
import type { PartyDto } from "Infrastructure/Api/Api";

type Props = {
  party: PartyDto;
};

export const MerchantPartyLegalEntity = ({ party }: Props) => (
  <>
    <MerchantPartyInfo party={party} />
    <ContactPersons publicPartyID={party.publicID ?? ""} />
  </>
);
